import { type BaseItem } from './common.js';

export enum DocumentType {
  DocumentSigner = 'DOCUMENT_SIGNER',
  FormSummary = 'FORM_SUMMARY',
  FreehandBodyDiagram = 'FREEHAND_BODY_DIAGRAM',
  InsuranceCard = 'INSURANCE_CARD',
  Image = 'IMAGE',
  OcrVerification = 'OCR_VERIFICATION',
  PhotoID = 'PHOTO_ID',
}

export enum UploadStatus {
  Uploading = 'UPLOADING',
  Scanning = 'SCANNING',
  Verified = 'VERIFIED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  ReviewVerified = 'REVIEW_VERIFIED',
  ExistingDocument = 'EXISTING_DOCUMENT',
}

export enum InsuranceCardSide {
  Front = 'FRONT',
  Back = 'BACK',
}

export interface BaseUpload {
  encounterId: string | null;
  ehrInformationId: string | null;
  gsPath: string;
  documentType: DocumentType;
  existingDocument: boolean;
  existingDocumentUploadDate: Date;
  previsitDocumentTemplateId: string | null;
  status: UploadStatus;
  patientInsuranceInformationId: string | null;
}

export interface PatientUpload extends BaseItem, BaseUpload {}

export interface SignedUploadURLResult {
  id: string;
  url: string;
  patientInsuranceInformationId?: string;
}

export interface FindAllOptions {
  encounterId?: string;
  ehrInformationId?: string;
  documentTypes?: DocumentType[];
  status?: UploadStatus;
  includeDeleted?: boolean;
  includeEncounterUploads?: boolean;
}

export enum PatientUploadKind {
  DocumentSigner = 'DOCUMENT_SIGNER',
  PhotoID = 'PHOTO_ID',
  InsuranceCard = 'INSURANCE_CARD',
}

enum PatientUploadCategory {
  EncounterDocumentPatientHistory = 'ENCOUNTER_DOCUMENT_PATIENT_HISTORY',
  FinancialPolicy = 'FINANCIAL_POLICY',
  MedicationPolicy = 'MEDICATION_POLICY',
  PatientAuthorization = 'PATIENT_AUTHORIZATION',
  PatientConsent = 'PATIENT_CONSENT',
  PrivacyPolicy = 'PRIVACY_POLICY',
}
interface BasePatientUpload {
  category: PatientUploadCategory | null;
  kind: PatientUploadKind;
}

export interface PatientUploadUpdate extends BasePatientUpload {
  gsPaths: string[];
}
